const loginImages = {
  BACKGROUND_IMAGE: require("./login-background-image.png"),
  LOGO_IMAGE: require("./login-logo.png"),
};
export { loginImages };
